import React from "react";
import CartaHeader from "./CartaHeader";
import CategoriesNav from "./CategoriesNav";
import ProductsSection from "./ProductsSection";
import MiRomanaDropdown from "./MiRomanaDropdown";
import style from "./Carta.module.css";

const LeftPanel = ({
  onPerfilClick,
  onVinosClick,
  mostrarVinos,
  headerPartRef,
  menuRef,
  categorias,
  categoriasSinProductos,
  categoriaID,
  getID,
  onCategoriaClick,
  itemsRef,
  onMouseDown,
  onMouseLeave,
  onMouseUp,
  onMouseMove,
  sectionRefs,
  preloadedProducts,
  onProductoClick,
  registrarCategoriaSinProductos,
  cargando,
  contentRef,
  onRecomendaciones,
  miRomanaVisible,
  onToggleMiRomana,
  onMiRomanaOption,
  miRomanaRef,
  onReservasClick,
  isMobile,
}) => {
  return (
    <div className={style.left_panel}>
      <div className={style.left_header}>
        <div className={style.header_container} ref={menuRef}>
          <CartaHeader
            onPerfilClick={onPerfilClick}
            onVinosClick={onVinosClick}
            mostrarVinos={mostrarVinos}
            headerPartRef={headerPartRef}
            onReservasClick={onReservasClick}
            isMobile={isMobile}
          />

          <CategoriesNav
            categorias={categorias}
            categoriasSinProductos={categoriasSinProductos}
            categoriaID={categoriaID}
            getID={getID}
            onCategoriaClick={onCategoriaClick}
            itemsRef={itemsRef}
            onMouseDown={onMouseDown}
            onMouseLeave={onMouseLeave}
            onMouseUp={onMouseUp}
            onMouseMove={onMouseMove}
          />
        </div>
      </div>

      <div className={style.productos_container} ref={contentRef}>
        <ProductsSection
          categorias={categorias}
          categoriasSinProductos={categoriasSinProductos}
          getID={getID}
          categoriaID={categoriaID}
          mostrarVinos={mostrarVinos}
          sectionRefs={sectionRefs}
          preloadedProducts={preloadedProducts}
          onProductoClick={onProductoClick}
          registrarCategoriaSinProductos={registrarCategoriaSinProductos}
          cargando={cargando}
        />
      </div>

      <div className={style.bottom_buttons_container}>
        {/* <button 
          className={style.formato_botones}
          onClick={onRecomendaciones}
        >
          Recomendaciones
        </button> */}
        <MiRomanaDropdown
          miRomanaVisible={miRomanaVisible}
          onToggleMiRomana={onToggleMiRomana}
          onMiRomanaOption={onMiRomanaOption}
          miRomanaRef={miRomanaRef}
        />
      </div>
    </div>
  );
};

export default LeftPanel;
